import { render, staticRenderFns } from "./CenterHeader.vue?vue&type=template&id=796d6eef&"
var script = {}
import style0 from "./CenterHeader.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports